import { buildSvgString, type SvgStringOpts } from '../../svgString';

import { data } from './data';

export const RadioButtonSVG = (opts?: SvgStringOpts): string => buildSvgString(data, opts);

export default RadioButtonSVG;
